<template>
    <div class="animate__animated animate__fadeIn">
        <div class="row" v-if="pespectiva">
            <form-textarea-editor
                class="mt-3"
                v-model="pespectiva.planos_futuro"
                label="Tem planos para o futuro?"
            />
            <form-textarea-editor
                class="mt-3"
                v-model="pespectiva.familia_corresponde"
                label="A familia corresponde a este interesse?"
            />
            <form-textarea-editor
                class="mt-3"
                v-model="pespectiva.recebe_apoio"
                label="O adolescente recebe algum tipo de  apoio ou acolhimento em relação aos interesses e planos para o futuro?"
            />
            <form-textarea-editor
                class="mt-3"
                v-model="pespectiva.recebe_influencia_negativa"
                label="O adolescente recebe algum tipo de influência negativa em relação aos interesses e planos para o futuro?"
            />
        </div>

        <div class="row px-2 d-flex justify-content-end">
            <button
                class="btn btn-success btn-submit"
                data-style="zoom-in"
                @click="submit"
                type="submit"
            >
                <i class="mdi mdi-content-save" />
                {{ $t("Salvar") }}
            </button>
        </div>
    </div>
</template>
<script>
export default {
    props: ["medida"],
    data() {
        return {
            pespectiva: {
                planos_futuro: "",
                familia_corresponde: "",
                recebe_apoio: "",
                recebe_influencia_negativa: "",
            },
        };
    },
    watch: {
        medida() {
            if (this.medida.pespectiva) {
                this.pespectiva = this.medida.pespectiva;
            }
        },
    },
    mounted() {
        if (this.medida.pespectiva) {
            this.pespectiva = this.medida.pespectiva;
        }
    },
    methods: {
        submit() {
            this.medida.pespectiva = this.pespectiva;

            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            if (ladda) {
                ladda.start();
            }
            this.$emit("submit");
        },
    },
};
</script>
